import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import SiteHeader from "@/components/shop/SiteHeader";
import SiteFooter from "@/components/shop/SiteFooter";
import CartDrawer from "@/components/shop/CartDrawer";

export default function Login() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email, pw);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome back, ${res.user.name || res.user.email}`);
      const redirect = res.user.role === "admin" ? "/admin" : from;
      navigate(redirect, { replace: true });
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50/50" data-testid="login-page">
      <SiteHeader />
      <CartDrawer />
      <section className="mx-auto max-w-md px-5 sm:px-8 py-16">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-3xl border border-slate-100 p-8 shadow-sm">
          <p className="text-xs uppercase tracking-[0.25em] text-amber-500 font-bold">Welcome back</p>
          <h1 className="mt-2 font-display text-3xl font-black text-[#0f2a5c]">Sign in</h1>
          <p className="mt-2 text-sm text-slate-500">Access order history & leave verified reviews.</p>

          <form onSubmit={submit} noValidate className="mt-6 space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs uppercase font-bold tracking-widest text-slate-500 mb-2 block">Email</label>
              <input
                data-testid="login-email"
                type="email" required autoFocus
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[#173a7a]"
              />
            </div>
            <div>
              <label className="text-xs uppercase font-bold tracking-widest text-slate-500 mb-2 block">Password</label>
              <input
                data-testid="login-password"
                type="password" required
                value={pw} onChange={(e) => setPw(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[#173a7a]"
              />
            </div>
            {err && <p className="text-sm text-red-600" data-testid="login-error">{err}</p>}
            <button data-testid="login-submit" disabled={loading}
              className="w-full py-3.5 rounded-full bg-[#173a7a] text-white font-semibold hover:bg-[#1a4694] disabled:opacity-60">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
          <p className="mt-6 text-sm text-slate-500 text-center">
            New to Morning Soft?{" "}
            <Link to="/signup" className="font-bold text-[#173a7a] hover:underline">Create an account</Link>
          </p>
        </motion.div>
      </section>
      <SiteFooter />
    </div>
  );
}
